import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { FormComponentLookup, FormBroadcast, FormNavigationConfig, DefaultFormConfig } from '@ptl/forms';
import { FormPageComponentClass } from '@ptl/forms';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { FormConfig } from '@ptl/forms';
import { ApplicationQualificationStateStructure } from 'src/app/angular-elements/shared/interfaces/applicationQualificationStateStructure.interface';
import { APPLICATION_QUALIFICATION_STATE_NAME, setApplicationQualificationService } from 'src/app/shared/reducers/applicationQualification.reducer';
import { PagePreauthorizationService } from '../../../medigap-preauthorization/page-preauthorization/page-preauthorization.service';


@FormComponentLookup('page-guaranteed-issue-eligibility')
@Component({
    selector: 'app-page-guranteed-issue-eligibility',
    templateUrl: './page-guranteed-issue-eligibility.component.html',
    styleUrls: ['./page-guranteed-issue-eligibility.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class PageGuaranteedIssueEligibilityComponent extends FormPageComponentClass<FormNavigationConfig> implements OnInit {

  // controls spinner
  isLoading = false;
  // controls error msg
  isQualified = true;

  constructor(
    private preauthService: PagePreauthorizationService,
    private reducerUtilityService: ReducerUtilityService,
  ) {
    super();
  }

  ngOnInit() {
    this.initPageConfig();
    let appQualificationResponse: ApplicationQualificationStateStructure = this.reducerUtilityService.getPayloadState(APPLICATION_QUALIFICATION_STATE_NAME);

    if (appQualificationResponse?.baseMessage?.returnCode === 200) {
      this.triggerFormUpdates(appQualificationResponse.payload.application);
    }
  }

  nextHook(formConfig): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let appQualificationResponse: ApplicationQualificationStateStructure = this.reducerUtilityService.getPayloadState(APPLICATION_QUALIFICATION_STATE_NAME);

      this.isLoading = true;
      this.isQualified = true;
      appQualificationResponse = await this.preauthService.getApplicationQualification();
      this.ngRedux.dispatch(setApplicationQualificationService(appQualificationResponse));

      if (appQualificationResponse?.payload?.qualified?.toLowerCase() === 'true') {
        this.triggerFormUpdates(appQualificationResponse.payload.application);
        resolve(true);
      }
      else {
        this.isQualified = false;
        reject();
        
        return;
      }
    });
  }

  triggerFormUpdates(applicationFlowKey: 'MU' | 'GI') {
    // This should never happen if the service is handled properly
    if (!applicationFlowKey) {
      console.error('No app qualification response provided for form stream trigger');
      return;
    }

    // MU/GI Main Flow form event to hide/show medical info page
    this.formStreamTrigger.triggerFormStream({
        formControlName: 'medigap-page-1',
        type: 'service',
        value: applicationFlowKey
    });
    
    // Birthday qualificaition trigger to hide/show the document upload page
    const bdayResponse = this.reducerUtilityService.getPayloadState('medigapEligibilityCheck.currentMedicarePolicyAndBirthday');
    this.formStreamTrigger.triggerFormStream({
        formControlName: 'birthday-qualificiation',
        type: 'service',
        value: bdayResponse
    });
  }
}
